import { getRequest, postRequest } from '../../../services/httpService';
import { stockDetails, stockStatusTypeDetails, TransferTypeDetails } from '../Stocks/stock.helper';

// Dynamic style for status tab button
export const statusTabButtonSx = (isSelected: boolean) => ({
  textTransform: 'none',
  fontWeight: isSelected ? 700 : 500,
  borderRadius: '0.625rem', // 10px
  fontFamily: 'Montserrat',
  borderWidth: 1,
  px: 2.5,
  py: 0.75,
  fontSize: '0.8rem',
  minWidth: 'unset',
  color: isSelected ? '#E17E61' : '#9E9E9E',
  borderColor: isSelected ? '#E17E61' : '#F3F4F7',
  backgroundColor: isSelected ? '#fff5f0' : '#f9f9f9',
  boxShadow: isSelected ? '4px 4px 9px 0px #00000021' : 'none',
  '&:hover': {
    borderColor: isSelected ? '#E17E61' : '#cfcfcf',
  },
});


export const filterInputSubLabelSx = {
  '& .MuiInputLabel-root': {
    px: 1,
    borderRadius: 2
  },   
  '& .MuiInputBase-root.Mui-disabled': {
    backgroundColor: '#f5f5f5',
  },                                 
};


export const activeBadgeSx = {
  '& .MuiBadge-dot': {
    backgroundColor: '#FF0000',
    width: '8px',
    height: '8px'
  }
};


export const modalHeaderSx = {
  fontFamily: 'Montserrat',
  fontWeight: 600,
  fontSize: '1.125rem', // 18px
  color: '#232323',
};


export const modalCloseIconSx = {
  color: '#9E9E9E',
  '&:hover': {
    backgroundColor: 'rgba(158, 158, 158, 0.1)',
  },
};


export const errorSx = {
  color: '#D32F2F',
  fontFamily: 'Montserrat',
  fontWeight: 500,
  fontSize: '0.8rem', 
  ml: 1,
};


export const warningSx = {
  color: '#F4C390',
  fontFamily: 'Montserrat',
  fontWeight: 500,
  fontSize: '0.8rem', 
  ml: 1,
};

export const noteSx = {
  color: '#1976d2',
  fontFamily: 'Montserrat',
  fontWeight: 500,
  fontSize: '0.8rem', 
  ml: 1,
};



export const modalCloseSx ={
  flex: 1,
  borderRadius: 3,
  textTransform: 'none',
  fontFamily: 'Montserrat',
  fontWeight: 600,
  fontSize: '0.875rem', // 14px
  color: '#666666',
  borderColor: '#E0E0E0',
  '&:hover': {
    borderColor: '#CCCCCC',
    backgroundColor: '#F5F5F5',
  },
  padding: 1.5,
};


export const modalSaveSx ={
  flex: 1,
  borderRadius: 3,
  textTransform: 'none',
  fontFamily: 'Montserrat',
  fontWeight: 600,
  fontSize: '0.875rem', // 14px
  backgroundColor: '#666666',
  '&:hover': {
    backgroundColor: '#555555',
  },
  padding: 1.5,
};

export const HeaderSx = {
  fontFamily: 'Montserrat',
  fontWeight: 700,
  fontSize: '1.125rem', // 18px
  color: '#232323',
};


export const subHeaderSx = {
  fontFamily: 'Montserrat',
  fontWeight: 600,
  fontSize: '1rem', // 16px
  color: '#232323',
};


export const ReportHeaderSx = {
  fontFamily: 'Montserrat',
  fontWeight: 700,
  fontSize: '1.125rem', // 18px
  color: '#232323',
};

export const ReportSubHeaderSx = {
  fontFamily: 'Montserrat',
  fontWeight: 700,
  fontSize: '1rem', // 16px
  color: '#232323',
};



export const LabelSx = {
  fontFamily: 'Nunito',
  fontWeight: 400,
  fontSize: '1rem', // 16px
  color: '#9E9E9E',
};



export const autocompleteSx ={
  maxHeight: 300,
  overflowY: 'auto',
};


export const checkBoxSx = {
  '&.Mui-checked': { color: '#4CAF50', bgcolor: '#EAF7EA', borderRadius: 2 },
  '&.Mui-disabled': { color: '#ccc', opacity: 0.5 }
};


export const tableHeaderSx = {
  fontWeight: 600,
  fontSize: '0.875rem', // 14px
  color: '#232323',
  fontFamily: 'Nunito',
  cursor: 'default',
};


export const tableColumnSx = {
  fontWeight: 500,
  fontSize: '0.875rem', // 14px
  color: '#232323',
  fontFamily: 'Nunito',
  cursor: 'default',
};


export const subTableHeaderSx = {
  fontWeight: 600,
  fontSize: '0.75rem', // 12px
  color: '#232323',
  fontFamily: 'Nunito',
  cursor: 'default',
};



export const valueSx = {
  fontWeight: 500,
  fontSize: '1rem', // 16px
  color: '#232323',
  fontFamily: 'Nunito',
  cursor: 'default',
};

export const expiryDetailsKeySx = {
  fontWeight: 500,
  fontSize: '0.75rem', // 12px
  color: '#9E9E9E',
  fontFamily: 'Nunito',
  cursor: 'default',
};


export const PrintQRBatchKeySx = {
  fontWeight: 500,
  fontSize: '0.875rem', // 14px
  color: '#9E9E9E',
  fontFamily: 'Nunito',
  cursor: 'default',
};


export const PrintQRItemKeySx = {
  fontWeight: 500,
  fontSize: '1rem', // 16px
  color: '#232323',
  fontFamily: 'Montserrat',
  cursor: 'default',
};


export const tableHeaderCellBaseSx = {
  backgroundColor: '#FAFAFA',
  whiteSpace: 'nowrap',
  border: 'none',
};


export const subTableHeaderCellBaseSx = {
  backgroundColor: '#FFFFFF',
  whiteSpace: 'nowrap',
  border: 'none',
};



export const tableHeaderLastCellRadiusSx = {
  borderTopRightRadius: '0.50rem', 
  borderBottomRightRadius: '0.50rem', 
};

export const tableHeaderFirstCellRadiusSx = {
  borderTopLeftRadius: '0.50rem', 
  borderBottomLeftRadius: '0.50rem', 
};

export const selectedTableCellSx = (isItemSelected: boolean) => ({
  backgroundColor: isItemSelected ? '#FFF8F6 !important' : 'inherit !important',
  verticalAlign: 'top',
  maxWidth:'350px'
});


export const openTableCellSx = (open: boolean) => ({
  backgroundColor: open ? '#FFF8F6 !important' : 'inherit !important',
  whiteSpace: 'nowrap',
  borderBottom: open ? 'none' : '1px solid rgba(224, 224, 224, 1)',
  borderTop: open ? '1px solid rgba(224, 224, 224, 1)' : 'none',
});

// PO Item Table Styles
export const poTableHeaderRowSx = {
  backgroundColor: '#F5F5F5',
};

export const poTableHeaderCellSx = {
  fontWeight: 600,
  fontFamily: 'Nunito',
  fontSize: '0.875rem',
  color: '#232323',
  whiteSpace: 'nowrap',
};

export const poTableBodyRowSx = {
  '&:hover': { backgroundColor: '#F9F9F9' },
};

export const poTableGroupHeaderSx = {
  backgroundColor: '#f5f5f5',
  py: 1,
};

// PO Table Column Configuration Type
export interface POTableColumn {
  field: string;
  headerKey: string;  // i18n key for header label
  minWidth?: number;
  width?: number;
  align?: 'left' | 'center' | 'right';
}

// Standard PO Item Table Columns Configuration
export const PO_ITEM_TABLE_COLUMNS: POTableColumn[] = [
  { field: 'delete', headerKey: '', width: 50 },
  { field: 'contract', headerKey: 'labels.contract', minWidth: 120 },
  { field: 'itemNameCode', headerKey: 'labels.item_name_code', minWidth: 200 },
  { field: 'prQty', headerKey: 'table_headers.pr_qty', minWidth: 80 },
  { field: 'prPendingQty', headerKey: 'table_headers.pr_pending_qty', minWidth: 100 },
  { field: 'poQty', headerKey: 'labels.po_qty', minWidth: 100 },
  { field: 'conversionFactor', headerKey: 'labels.conversion_factor', minWidth: 120 },
  { field: 'baseCostPrice', headerKey: 'labels.base_cost_price', minWidth: 120 },
  { field: 'baseMrp', headerKey: 'labels.base_mrp', minWidth: 100 },
  { field: 'totalCostAmount', headerKey: 'labels.total_cost_amount', minWidth: 140 },
  { field: 'totalMrp', headerKey: 'labels.total_mrp', minWidth: 120 },
  { field: 'totalNetAmount', headerKey: 'labels.total_net_amount', minWidth: 140 },
  { field: 'availableStock', headerKey: 'labels.available_stock', minWidth: 130 },
  { field: 'discount', headerKey: 'labels.discount', minWidth: 100 },
  { field: 'sgst', headerKey: 'labels.sgst_percentage_amount', minWidth: 180 },
  { field: 'cgst', headerKey: 'labels.cgst_percentage_amount', minWidth: 180 },
  { field: 'igst', headerKey: 'labels.igst_percentage_amount', minWidth: 180 },
  { field: 'netAmount', headerKey: 'labels.net_amount_col', minWidth: 120 },
  { field: 'specification', headerKey: 'labels.specification', minWidth: 150 },
  { field: 'hsnCode', headerKey: 'labels.hsn_code', minWidth: 100 },
];

// PO View Table Columns (simplified for read-only view)
export const PO_VIEW_TABLE_COLUMNS: POTableColumn[] = [
  { field: 'sno', headerKey: 'S.No' },
  { field: 'itemNameCode', headerKey: 'Item Name | Code', minWidth: 200 },
  { field: 'quantity', headerKey: 'Quantity' },
  { field: 'uom', headerKey: 'UOM' },
  { field: 'costPrice', headerKey: 'Cost Price' },
  { field: 'mrp', headerKey: 'MRP' },
  { field: 'discount', headerKey: 'Discount %' },
  { field: 'totalAmount', headerKey: 'Total Amount' },
  { field: 'pendingQty', headerKey: 'Pending Qty' },
];

// PO Expanded Row Details Table Columns (for list view expanded row)
export const PO_EXPANDED_TABLE_COLUMNS: POTableColumn[] = [
  { field: 'checkbox', headerKey: '', width: 50 },
  { field: 'contract', headerKey: 'table_headers.contract', minWidth: 100 },
  { field: 'itemNameCode', headerKey: 'table_headers.item_name_code', minWidth: 200 },
  { field: 'prQty', headerKey: 'table_headers.pr_qty', minWidth: 80 },
  { field: 'prPendingQty', headerKey: 'table_headers.pr_pending_qty', minWidth: 100 },
  { field: 'poQty', headerKey: 'table_headers.po_qty', minWidth: 80 },
  { field: 'baseCostPrice', headerKey: 'table_headers.base_cost_price', minWidth: 120 },
  { field: 'costAmount', headerKey: 'table_headers.cost_amount', minWidth: 120 },
  { field: 'baseMrp', headerKey: 'table_headers.base_mrp', minWidth: 100 },
  { field: 'amount', headerKey: 'table_headers.amount', minWidth: 100 },
  { field: 'availableStock', headerKey: 'table_headers.available_stock', minWidth: 100 },
  { field: 'discount', headerKey: 'table_headers.discount', minWidth: 140 },
  { field: 'sgst', headerKey: 'table_headers.sgst_percentage_amount', minWidth: 150 },
  { field: 'cgst', headerKey: 'table_headers.cgst_percentage_amount', minWidth: 150 },
  { field: 'igst', headerKey: 'table_headers.igst_percentage_amount', minWidth: 150 },
  { field: 'netAmount', headerKey: 'table_headers.net_amount', minWidth: 120 },
  { field: 'specification', headerKey: 'table_headers.specification', minWidth: 150 },
  { field: 'hsnCode', headerKey: 'table_headers.hsn_code', minWidth: 100 },
];

// Helper to get cell sx based on column config
export const getPoTableCellSx = (column: POTableColumn) => ({
  ...poTableHeaderCellSx,
  ...(column.minWidth && { minWidth: column.minWidth }),
  ...(column.width && { width: column.width }),
});



export const fromTableRowSx = {
  maxWidth:'350px',
  verticalAlign: 'top'
};



export const tableScrollSx={
  '::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '::-webkit-scrollbar-thumb': {
    backgroundColor: '#DADADA',
    borderRadius: '4px',
  },
  '::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#B0B0B0', // Slightly darker color on hover
  },
  '::-webkit-scrollbar-track': {
    backgroundColor: '#F1F1F1',
  }
};


// Popover styles for item info popover
export const popoverPaperSx = {
  pointerEvents: 'auto',
  p: 0,
  maxWidth: '22.5rem',
  borderRadius: '0.75rem',
  overflow: 'hidden',
  position: 'relative',
  bgcolor: 'background.paper',
  '&:before': {
    content: '""',
    position: 'absolute',
    width: '0.875rem',
    height: '0.875rem',
    bgcolor: 'background.paper',
    transform: 'rotate(45deg)',
    top: '-0.4375rem',
    left: 'calc(50% - 0.4375rem)',
    boxShadow: '0px -1px 1px rgba(0,0,0,0.04)',
    zIndex: 0,
  },
};

export const popoverHeaderSx = {
  px: '1rem',
  py: '0.75rem',
  bgcolor: 'background.paper',
};

export const popoverBodySx = {
  p: '1rem',
};

export const popoverGridSx = {
  display: 'grid',
  gridTemplateColumns: '1fr 24px auto',
  rowGap: '0.75rem',
  alignItems: 'center',
};



export const tertiaryButtonSx ={
  borderRadius: 2,
  textTransform: 'none',
  border: 0,
  fontFamily: 'Montserrat',
  fontWeight: 700,
  fontSize: '0.875rem', // 14px
  color: '#666666',
  backgroundColor: '#F5F5F5',
  '&:hover': {
    borderColor: '#666666',
    backgroundColor: '#F5F5F5',
  },
  paddingY: 1,
  paddingX: 4,
};


export const QuaternaryButtonSx ={
  borderRadius: 2,
  textTransform: 'none',
  fontFamily: 'Montserrat',
  fontWeight: 600,
  fontSize: '0.875rem', // 14px
  color: '#666666',
  backgroundColor: '#FBFBFB',
  '&:hover': {
    borderColor: '#666666',
    backgroundColor: '#FBFBFB',
  },
  paddingY: 0.7,
  paddingX: 4,
  border: '2px dashed #E0E0E0',                      
};



export const secondaryButtonSx ={
  borderRadius: 2,
  textTransform: 'none',
  border: 2,
  fontFamily: 'Montserrat',
  fontWeight: 700,
  fontSize: '0.875rem', // 14px
  color: '#666666',
  borderColor: '#666666',
  '&:hover': {
    borderColor: '#666666',
    backgroundColor: '#F5F5F5',
  },
  paddingY: 1,
  paddingX: 4,
};


export const primaryButtonSx ={
  borderRadius: 2,
  textTransform: 'none',
  fontFamily: 'Montserrat',
  fontWeight: 700,
  fontSize: '0.875rem', // 14px
  backgroundColor: '#666666',
  '&:hover': {
    backgroundColor: '#555555',
  },
  paddingY: 1,
  paddingX: 4,
};


// Create a helper function to handle styles and event handlers for custom multiselect autocomplete options
export const getOptionStylesAndHandlersForMultiSelectAutocomplete = (selected: boolean) => {
  const baseStyle = {
    padding: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '0.0625rem solid #EEEEEF',
    marginLeft: '0.625rem',
    marginRight: '0.625rem',
    cursor: 'pointer',
    backgroundColor: selected ? '#FFF8F6' : undefined,
  };

  const eventHandlers = {
    onMouseEnter: (e: React.MouseEvent<HTMLLIElement>) => {
      e.currentTarget.style.backgroundColor = '#F8F8F8';  // Light hover color
    },
    onMouseLeave: (e: React.MouseEvent<HTMLLIElement>) => {
      e.currentTarget.style.backgroundColor = selected ? '#FFF8F6' : '';
    },
    onFocus: (e: React.FocusEvent<HTMLLIElement>) => {
      e.currentTarget.style.backgroundColor = '#F8F8F8'; // Light focus color
    },
    onBlur: (e: React.FocusEvent<HTMLLIElement>) => {
      e.currentTarget.style.backgroundColor = selected ? '#FFF8F6' : '';
    },
  };

  return { style: baseStyle, ...eventHandlers };
};



export const tableInputSubLabelSx = {
  '& .MuiInputLabel-root': {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '0.875rem', // 14px
    color: '#9E9E9E',
    bgcolor: '#FFFFFF',
    px: 1,
    borderRadius: 2
  },                     
};



//---------------------------------------------------

export type uploadImages = {
    file: string; 
  };

export interface UploadedImageType {
  name: string;
  image: string; 
  size?: string; 
}
export interface Department {
  id: number;
  name: string;
  name_label?: string;
  state?: string | null;
  state_name_label?: string | null;
  is_default_department?: boolean;
  department_name?: string;
}

export interface Clinic {
  id: number;
  name: string;
  code: string;
  name_label: string;
  inventory_level_limit: number;
  departments: Department[];
}

interface ClinicResponse {
  objects: Array<{
    id: number;
    name: string;
    code: string;
    name_label: string;
    inventory_level_limit: number;
    departments: Array<{
      id: number;
      name: string;
      name_label: string;
      is_default_department: boolean;
    }>;
  }>;
}

export const mapClinicsResponse = (response: ClinicResponse): Clinic[] => {
  return response.objects.map((clinic) => ({
    id: clinic.id,
    name: clinic.name,
    code: clinic.code,
    name_label: clinic.name_label,
    inventory_level_limit: clinic.inventory_level_limit,
    departments: clinic.departments.map((dept) => ({
      id: dept.id,
      name: dept.name,
      name_label: dept.name_label,
      is_default_department: dept.is_default_department,
    })),
  }));
};


// get clinic list API call
export interface GetClinicListParams {
  limit?: number;
  offset?: number;
  search?: string;
  order_by?: string;
  name__icontains?: string;
}

export function getClinicList(params: GetClinicListParams = {}): Promise<ClinicResponse> {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, String(value));
    }
  });

  const url = `/clinics/?${query.toString()}`;
  return getRequest(url, { responseType: 'json' });
}




export interface ItemGroup {
  id: number;
  description: string;
  code: string;
  label: string;
}

interface itemGroupResponse {
  objects: ItemGroup[];
}


export const mapItemGroupResponse = (response: itemGroupResponse): ItemGroup[] => {
  return response.objects.map((item) => ({
    id: item.id,
    description: item.description,
    code: item.code,
    label: item.description,
  }));
};


export interface itemgroupParams {
  limit?: number;
  offset?: number;
}


export function getItemGroupList(params: itemgroupParams = {}): Promise<itemGroupResponse> {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, String(value));
    }
  });

  const url = `/item-group/?${query.toString()}`;
  return getRequest(url, { responseType: 'json' });
}


export interface ItemCategory {
  id: number;
  description: string;
  code: string;
  label: string;
}

interface itemCategoryResponse {
  objects: ItemCategory[];
}


export const mapItemCategoryResponse = (response: itemCategoryResponse): ItemCategory[] => {
  return response.objects.map((item) => ({
    id: item.id,
    description: item.description,
    code: item.code,
    label: item.description,
  }));
};


export interface ItemCategoryParams {
  limit?: number;
  offset?: number;
}


export function getItemCategoryList(params: ItemCategoryParams = {}): Promise<itemCategoryResponse> {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, String(value));
    }
  });

  const url = `/item-category/?${query.toString()}`;
  return getRequest(url, { responseType: 'json' });
}



// get inventory item list API call
export interface GetInventoryItemsParams {
  clinic_id: number;
  dept_id: number;
  search?: string;
  item_category_id?: string;
  item_group_id?: string;
}


export function getInventoryItems(params: GetInventoryItemsParams): Promise<InventoryItemApiResponse> {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, String(value));
    }
  });

  const url = `item-store-clinic-search/?${query.toString()}`;
  return getRequest(url, { responseType: 'json' });
}


export interface InventoryItem {
item_id: number;
item_name: string;
item_code: string;
clinic_id: number;
clinic_name: string;
dept_id: number;
dept_name: string;
shelf_id: number;
shelf_name: string;
base_uom_id: number;
base_uom_name: string;
base_uom_static_field: string;
rack_id: number;
rack_name: string;
bin_id: number | null;
bin_name: string | null;
min_qty: number;
max_qty: number;
reorder_level: number | null;
is_active: boolean;
uom_conversions: uomDetails[];
batch_info: BatchInfo[];
cgst_percent: number;
sgst_percent: number;
igst_percent: number;
base_mrp: number;
base_cost: number;
min_expiry_in_days: number;
available_qty: number;
discount_percentage: number | null;
total_amount: number;
batches?: BatchInfo[];
total_qty: number;
available_stock_uom?: string;
is_perishable: boolean;
}

interface InventoryItemApiResponse {
  objects: Array<{
    item_id: number;
    item_name: string;
    item_code: string;
    clinic_id: number;
    clinic_name: string;
    dept_id: number;
    dept_name: string;
    shelf_id: number;
    shelf_name: string;
    base_uom_id: number;
    base_uom_name: string;
    base_uom_static_field: string;
    rack_id: number;
    rack_name: string;
    bin_id: number | null;
    bin_name: string | null;
    min_qty: number;
    max_qty: number;
    reorder_level: number | null;
    is_active: boolean;
    uom_conversions: uomDetails[];
    batches: BatchInfo[];
    CGST: number;
    SGST: number;
    IGST: number;
    mrp: number;
    cost_price: number;
    min_expiry_in_days: number;
    available_qty: number;
    available_uom_id: number;
    available_uom_name: string;
    discount_percentage: number | null;
    total_amount: number;
    total_qty: number;
    is_perishable: boolean;
  }>;
}

export const mapApiResponseToInventoryItems = (response: InventoryItemApiResponse): InventoryItem[] => {
  return response.objects.map((item) => ({
    item_id: item.item_id,
    item_name: item.item_name,
    item_code: item.item_code,
    clinic_id: item.clinic_id,
    clinic_name: item.clinic_name,
    dept_id: item.dept_id,
    dept_name: item.dept_name,
    shelf_id: item.shelf_id,
    shelf_name: item.shelf_name,
    rack_id: item.rack_id,
    rack_name: item.rack_name,
    bin_id: item.bin_id,
    bin_name: item.bin_name,
    base_uom_id: item.base_uom_id,
    base_uom_static_field: item.base_uom_static_field,
    base_uom_name: item.base_uom_name,
    min_qty: item.min_qty,
    max_qty: item.max_qty,
    reorder_level: item.reorder_level,
    is_active: item.is_active,
    uom_conversions: item.uom_conversions || [], // Use uom_conversions to match InventoryItem interface
    batch_info: item.batches || [],
    cgst_percent: item.CGST,
    sgst_percent: item.SGST,
    igst_percent: item.IGST,
    base_mrp: item.mrp,
    base_cost: item.cost_price,
    min_expiry_in_days: item.min_expiry_in_days,
    available_qty:item.available_qty,
    ...(item.batches ? { batches: item.batches } : {}),
    available_stock_qty: item.available_qty,
    available_stock_uom: item.base_uom_name,
    available_stock_uom_id: item.base_uom_id,
    discount_percentage: item.discount_percentage || null,
    total_amount: item.total_amount,
    total_qty: item.total_qty,
    is_perishable:item.is_perishable
  }));
};

export interface uomDetails {
  id: number;
  item_id: number;
  item_name: string;
  uom_code : string;
  code?: string;
  uom_id : number;
  uom_static_field: string;
  conversion_factor: number;
  converted_cost_price: number;
  converted_mrp: number;
}


export type list_header_type_details =  'all_stock' | 'available_stock' | 'indent_required' | 'purchase_required';

export type list_type_details =  'All' | 'Stock' | 'GRN' | 'Received';


export type stockReportExportType = 'pdf' | 'excel' | 'print';

// GetAvailableStockList API call
export interface GetAvailableStockListParams {
  limit?: number;
  offset?: number;
  search?: string;
  from_date?: string;
  is_low_stock?: boolean;
  is_near_expiry?: boolean;
  is_no_stock?: boolean;
  is_expired?: boolean;
  item_category_id?: string;
  item_group_id?: string;
  list_header_type?: list_header_type_details;
  list_type?: list_type_details;
  ordering?: string;
  to_date?: string;
  clinic_id?: number;
  dept_id?: number;
}


export function getAvailableStockList(params: GetAvailableStockListParams): Promise<AvailableStockListResponse> {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, String(value));
    }
  });

  const url = `/available-stock-list/?${query.toString()}`;
  return getRequest(url, { responseType: 'json' });
}

// Get Available Stock List ItemWise API call (for StockDetailsPage)
export function getAvailableStockListItem(params: GetAvailableStockListParams): Promise<AvailableStockListResponse> {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, String(value));
    }
  });

  const url = `/available-stock-list/available-stock-list-item/?${query.toString()}`;
  return getRequest(url, { responseType: 'json' });
}

// Get Available Stock List Count API call
export interface StockListCountAPIResponse {
  list_type_counts: {
    All: number;
    Stock: number;
    GRN: number;
    Received: number;
  };
  list_header_type_counts: {
    all_stock: number;
    available_stock: number;
    indent_required: number;
    purchase_required: number;
  };
}

export function getAvailableStockListCount(params: GetAvailableStockListParams): Promise<StockListCountAPIResponse> {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, String(value));
    }
  });

  const url = `/available-stock-list/available-stock-list-count/?${query.toString()}`;
  return getRequest(url, { responseType: 'json' });
}


export interface stockListCounts {
      all_stock: number;
      available_stock: number;
      indent_required: number;
      purchase_required: number;
      list_type_counts:{
        All: number;
        Stock: number;
        GRN: number;
        Received: number;
      }
}

interface AvailableStockListResponse {
  meta : {
    total_count: number;
    limit: number;
    offset: number;
    list_header_type_counts: stockListCounts;
  }
  objects: Array<{
  stock_transaction_id: number;     // always unique id
  date: string;                 
  item_code: string;            
  item_name: string;             
  batch_code: string;            
  expiry_date: string;           
  item_group: string;          
  item_category: string;         
  is_free: boolean;              
  transfer_type: TransferTypeDetails ;         
  opening_stock: string;        
  used_stock: string;  
  addition_stock: string;         
  closing_stock: string;        
  base_cost: string;            
  total_cost: string;            
  base_mrp: string;              
  total_mrp: string;                        
  stock_status: stockStatusTypeDetails; 
  item_id: number;       
  base_uom_id:number;
  base_uom_name:string;   
  base_uom_code?: string;       
  is_low_stock: boolean;
  is_no_stock: boolean;
  is_near_expiry: boolean;
  is_expired: boolean;
  clinic_name : string;
  clinic_id : number;
  store_name : string;
  store_id : number;
  uom_object : uomDetails[];
  batch_object : BatchInfo[]; 
  batch_id: number;  
  barcode: BarcodeDataResponse | null;
  is_barcode_generated: boolean;
  max_qty?: number;   
  is_perishable: boolean;   
}>;
};


export interface BatchInfo {
  id: number;
  batch_number: string;
  expiry_date: string;
  available_stock: number;
  available_uom_id: number | undefined;
  available_uom_name: string | undefined; 
  available_uom_static_field: string | undefined;
  base_mrp: number;
  base_cost: number;
  conversion_factor: number;
  is_hold?: boolean;
};


export const mapAvailableStockList = (response: AvailableStockListResponse): stockDetails[] => {
  if (!response?.objects || !Array.isArray(response.objects)) {
    return [];
  }
  return response.objects.map((item, index) => ({
    // Generate unique ID using combination of item_id, store_id, and index as fallback
    id: item.stock_transaction_id ?? `${item.item_id}_${item.store_id}_${index}`,
    itemId: item.item_id,
    batchId: item.batch_id,
    date: item.date,
    itemCode: item.item_code,
    itemName: item.item_name,
    batchCode: item.batch_code,
    expiryDate: item.expiry_date,
    itemGroup: item.item_group,
    itemCategory: item.item_category,
    isFree: item.is_free,
    transferType: item.transfer_type,
    openingStock: Number(item.opening_stock),
    usedStock: Number(item.used_stock),
    stockAddition: Number(item.addition_stock),
    closingStock: Number(item.closing_stock),
    baseCost: Number(item.base_cost),
    totalCost: Number(item.total_cost),
    baseMrp:  Number(item.base_mrp),
    totalMrp: Number(item.total_mrp),
    isScanBarCode: true,
    requestTo: item.store_id,  // Store ID
    stock_status: item.stock_status,  
    base_uom_name: item.base_uom_name,
    base_uom_code: item.base_uom_code,
    base_uom_id:item.base_uom_id,
    is_low_stock: item.is_low_stock,
    is_no_stock: item.is_no_stock,
    is_near_expiry: item.is_near_expiry,
    is_expired: item.is_expired || false,
    clinic_name : item.clinic_name,
    clinic_id : item.clinic_id,
    store_name : item.store_name,
    store_id : item.store_id,
    uom_conversions: item.uom_object || [],
    batch_info: item.batch_object || [],
    barcode : item.barcode || null,
    uom_object: item.uom_object || [],
    batch_object: item.batch_object || [],
    is_barcode_generated: item.is_barcode_generated ?? false,
    max_qty: item.max_qty ?? 0,
    is_perishable: item.is_perishable ?? false,
  }));
};


export interface ConsumptionItem{
  id: number; //unique id
  date: string;
  item_id: number;
  item_name: string;
  item_code: string;
  batch_code: string;
  batch_id: number | null;
  expiry_date: string;
  clinic_id: number;
  clinic_name: string;
  dept_id: number;
  dept_name: string;
  available_quantity: number;
  available_uom_id: number;
  available_uom_name: string;
  uom_conversions: uomDetails[];
  batch_info: BatchInfo[];
  base_mrp: number;
  base_cost: number;
  total_cost: number;
  total_mrp: number;
  is_perishable: boolean;
}


export const mapApiResponseToConsumptionItems = (response: AvailableStockListResponse): ConsumptionItem[] => {
  if (!response?.objects || !Array.isArray(response.objects)) {
    return [];
  }
  return response.objects.map((item) => ({
    id: item.stock_transaction_id,
    date: item.date,
    item_id: item.item_id,
    item_name: item.item_name,
    item_code: item.item_code,
    batch_code: item.batch_code,
    expiry_date: item.expiry_date,
    clinic_id: item.clinic_id,
    clinic_name: item.clinic_name,
    dept_id: item.store_id,
    dept_name: item.store_name,
    uom_conversions: item.uom_object || [],
    batch_info: item.batch_object || [],
    base_mrp: Number(item.base_mrp),
    base_cost: Number(item.base_cost),
    total_cost: Number(item.total_cost),
    total_mrp: Number(item.total_mrp),
    available_quantity: Number(item.closing_stock),
    available_uom_id: item.base_uom_id,
    available_uom_name: item.base_uom_name,
    batch_id: item.batch_id || null,
    is_perishable: item.is_perishable ?? false,
  }));
};





interface QRScanResponse {
  stock_transaction_id: number;    //unique id
  date: string;                 
  item_code: string;            
  item_name: string;             
  batch_code: string;            
  expiry_date: string;           
  item_group: string;          
  item_category: string;         
  is_free: boolean;              
  transfer_type: TransferTypeDetails ;         
  opening_stock: string;        
  used_stock: string;  
  addition_stock: string;         
  closing_stock: string;        
  base_cost: string;            
  total_cost: string;            
  base_mrp: string;              
  total_mrp: string;                        
  stock_status: stockStatusTypeDetails; 
  item_id: number;       
  base_uom_id:number;
  base_uom_name:string;          
  is_low_stock: boolean;
  is_no_stock: boolean;
  is_near_expiry: boolean;  
  clinic_name : string;
  clinic_id : number;
  store_name : string;
  store_id : number;
  uom_object : uomDetails[];
  batch_object : BatchInfo[]; 
  batch_id: number;  
  barcode: BarcodeDataResponse | null;  
  is_perishable: boolean;    
};

export const mapApiResponseToConsumptionItemsFromQRScan = (response: QRScanResponse[]): ConsumptionItem[] => {
  return response.map((item) => ({
    id: item.stock_transaction_id,
    date: item.date,
    item_id: item.item_id,
    item_name: item.item_name,
    item_code: item.item_code,
    batch_code: item.batch_code,
    expiry_date: item.expiry_date,
    clinic_id: item.clinic_id,
    clinic_name: item.clinic_name,
    dept_id: item.store_id,
    dept_name: item.store_name,
    uom_conversions: item.uom_object || [],
    batch_info: item.batch_object || [],
    base_mrp: Number(item.base_mrp),
    base_cost: Number(item.base_cost),
    total_cost: Number(item.total_cost),
    total_mrp: Number(item.total_mrp),
    available_quantity: Number(item.closing_stock),
    available_uom_id: item.base_uom_id,
    available_uom_name: item.base_uom_name,
    batch_id: item.batch_id || null,
    is_perishable: item.is_perishable ?? false,
  }));
};


export interface Partner {
  id: number;
  age: number | null;
  created_on: string | null; // ISO datetime
  first_name: string | null;
  last_name: string | null;
  date_of_birth: string | null; // YYYY-MM-DD
  gender__name: string | null;
  medical_record_no: string | null;
  mobile_number: string | null;
  alternate_email: string | null;
  is_lead: boolean | null;
  photo: string | null;
  gender__name_label: string | null;
};


export interface PatientDetails {
id: number;
first_name: string;
last_name: string;
middle_name: string | null;
date_of_birth: string;
medical_record_no: string;
mobile_number: string;
mobile_number_country_code: string | null;
clinic: number | null;
alternate_email: string | null;
partner: Partner | null;
gender__name: string | null;
age: number | null;
reason_for_visit: string | null;
checked_in_date: string | null; // ISO datetime
gender__name_label: string | null;
reason_for_visit_label: string | null;
};


export interface CheckedInPatientListParams {
clinic_id: number;
};


export interface CheckedInPatientListResponse {
meta: {
total_count: number;
limit: number;
offset: number;
};
objects: PatientDetails[];
};


export function getCheckedInPatientList(
  params: CheckedInPatientListParams
): Promise<CheckedInPatientListResponse> {
  const query = new URLSearchParams();


  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, String(value));
    }
  });

  const url = `/check-in-patient-list-inventory/?${query.toString()}`;
  return getRequest(url, { responseType: 'json' });
}


export const mapCheckedInPatients = (
  data: CheckedInPatientListResponse
): PatientDetails[] => {
  return data.objects;
};



export interface PackageDetails {
    id: number;
    patient: number;
    package: number;
    package_name: string;
};



export interface getPatientPackagesResponse {
meta: {
total_count: number;
limit: number;
offset: number;
};
objects: Array<{
   package_details: PackageDetails;
}>;
};

export function getPatientPackages(
  patient_id : number
): Promise<getPatientPackagesResponse> {
  const url = `/patient-packages/patient/${patient_id}`;
  return getRequest(url, { responseType: 'json' });
};



export interface barcodeBatchInfo {
  item_id: number;
  item_name: string;
  batch_code: string;
  batch_id: number;
  store_id: number;
}

export interface BarcodeDataResponse {
  batch_id: number;
  batch_code: string;
  item_id: number;
  item_name: string;
  barcode_text: string;
  barcode_image_url: string;
  proxy_image_url: string;
}


export function generateStockBarcode(data: barcodeBatchInfo): Promise<BarcodeDataResponse> {
  const url = '/batch-barcode/';  
  return postRequest(url, data, { responseType: 'json' });
}

export function getBatchBarcodeDetails(batchId: number): Promise<BarcodeDataResponse> {
  const url = `/available-stock-list/batch-barcode-details/?batch_id=${batchId}`;
  return getRequest(url, { responseType: 'json' });
}



// REUSABLE QUANTITY INPUT UTILITIES
/**
 * Handles keydown events for quantity input fields to block invalid characters
 * Blocks: decimals (.), commas (,), scientific notation (e, E), signs (-, +)
 */
export const handleQuantityKeyDown = (e: React.KeyboardEvent) => {
  if (e.key === '.' || e.key === ',' || e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+') {
    e.preventDefault();
  }
};

/**
 * Sanitizes and validates quantity input value
 * @param rawValue - The raw input value from the text field
 * @param maxValue - Maximum allowed value (default: 9999)
 * @param minValue - Minimum allowed value (default: 1)
 * @returns Sanitized quantity value or empty string
 */
export const sanitizeQuantityInput = (
  rawValue: string, 
  maxValue: number = 9999, 
): number | string => {
  // Allow empty string for clearing
  if (rawValue === '') {
    return '';
  }
  
  // Remove non-digit characters and leading zeros
  const sanitized = rawValue.replace(/\D+/g, '').replace(/^0+/, '');
  
  if (sanitized === '') {
    return '';
  }
  
  // Enforce maximum limit (minimum is enforced on blur)
  const quantity = Math.min(maxValue, Number(sanitized));
  return quantity;
};


/**
 * Handles blur event for quantity input to ensure valid value
 * @param currentValue - Current quantity value
 * @param defaultValue - Default value to set if current is invalid (default: 1)
 * @returns Valid quantity value
 */
export const handleQuantityBlur = (
  currentValue: number | string | undefined, 
  defaultValue: number = 1
): number => {
  if (currentValue === '' || currentValue === 0 || currentValue === undefined) {
    return defaultValue;
  }
  return typeof currentValue === 'number' ? currentValue : defaultValue;
};


export const isPrintQuantityInvalid = (value: number | string | undefined): boolean => {
  return value === '' || (typeof value === 'number' && value < 1);
};


export const getPrintQuantityHelperText = (
  value: number | string | undefined, 
  customMessage: string
): string => {
  return value === '' ? customMessage : '';
};



export interface scanAvailableStockQRPayload {
  barcode_text: string;
}


export function scanAvailableStockQR(data: scanAvailableStockQRPayload): Promise<QRScanResponse> {
  const url = `/batch-barcode-scan/?barcode_text=${data.barcode_text}`;
  return getRequest(url, { responseType: 'json' });
}









// Each Row Interface
export interface StockReportItem {
  date: string;
  item_code: string;
  item_name: string;
  item_group: string;
  item_category: string;
  batch_code: string;
  expiry_date: string;
  opening_stock: number;
  used_stock: number;
  addition_stock: number;
  closing_stock: number;
  base_cost: number;
  total_cost: number;
  base_mrp: number;
  total_mrp: number;
  cgst_percentage: number;
  cgst_amount: number;
  sgst_percentage: number;
  sgst_amount: number;
  net_amount: number;
  clinic_name: string;
  store_name: string;

  // extra metadata coming in your API
  clinic_id: number;
  store_id: number;
  item_id: number;
  batch_id: number;
  stock_transaction_id: number; // unique id
}


export interface StockReportCounts {
  total?: number;
  available_stock?: number;
  near_expiry?: number;
  low_stock?: number;
  no_stock?: number;
  expired?: number;
}

export interface StockReportResponse {
  fields: Record<string, string>;
  column_order: string[];
  data: StockReportItem[];
  counts?: StockReportCounts;
}

export function getAvailableStockListForReport(type : list_header_type_details, clinicId?: number): Promise<StockReportResponse> {
  let url = `/available-stock-list-report/?list_header_type=${type}`;
  if (clinicId) {
    url += `&clinic_id=${clinicId}`;
  }
  return getRequest(url, { responseType: 'json' });
}


export interface LocalUserClinics {
  clinic_id?: number;
  clinic__name?: string;
  clinic_name?: string;
  clinic_name_label?: string;
  clinic__name_label?: string;
  inventory_level_limit?: number;
  id?: number;
  code?: string;
}
export interface LocalUserDepartments {
  department_id?: number;
  department_name?: string;
  id?: number;
  department__name?: string;
  department_name_label?: string;
  department__name_label?: string;
  state?: string | null;
  state_name_label?: string | null;
  is_default_department?: boolean;
}
export interface UserClinicDepartments {
  first_name: string;
  last_name: string;
  gender: string;
  gender_label : string;
  id: number;
  clinics?: LocalUserClinics[];
  clinic_department?: Record<string, LocalUserDepartments[]>;
}


export function mapUserClinicsResponse(user: UserClinicDepartments | null | undefined): Clinic[] {
  if (!user) return [];
  const clinicsFromUser = Array.isArray(user.clinics) ? (user.clinics as LocalUserClinics[]) : [];
  const clinicDept = user.clinic_department || {};
  const mapped: Clinic[] = clinicsFromUser
    .map((c) => {
      const clinicId = Number(c.clinic_id ?? c.id ?? 0);
      const clinicName = c.clinic__name ?? c.clinic_name ?? '';
      const clinicNameLabel = c.clinic__name_label ?? c.clinic_name_label ?? '';
      const departmentsRaw = clinicDept?.[String(clinicId)] || clinicDept?.[clinicId] || [];
      const departments: Department[] = Array.isArray(departmentsRaw)
        ? departmentsRaw.map((d) => ({ id: Number(d.department_id ?? d.id ?? 0), name: d.department_name ?? d.department__name ?? '' , name_label: d.department__name_label ?? d.department_name_label ?? '', state: d.state ?? null , state_name_label: d.state_name_label ?? null, is_default_department: d.is_default_department ?? false }))
        : [];
      return {
        id: clinicId,
        name: clinicName,
        code: c.code ?? '',
        name_label: clinicNameLabel,
        inventory_level_limit: c.inventory_level_limit ?? 0,
        departments,
      } as Clinic;
    })
    .filter((x) => Boolean(x && x.id));
  return mapped;
}